import axios from 'axios';

export default function auth(state = {}, action) {
  switch (action.type) {
    case 'search_box_update':
      return {
        ...state,
        searchBox: action.payload}
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./client/reducers/app.js